import { render, staticRenderFns } from "./safe-img.vue?vue&type=template&id=2d73c4ab&scoped=true&lang=pug&"
import script from "./safe-img.vue?vue&type=script&lang=js&"
export * from "./safe-img.vue?vue&type=script&lang=js&"
import style0 from "./safe-img.vue?vue&type=style&index=0&id=2d73c4ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73c4ab",
  null
  
)

export default component.exports